import { configureStore } from "@reduxjs/toolkit";
import authReducer, { clearAuth } from "@/store/slices/authSlice";
import uiReducer from "@/store/slices/uiSlice";
import borrowersReducer from "@/store/slices/borrowersSlice";
import agentReducer from "@/agent/store/agentSlice";
import { agentClient } from "@/agent/agentClient";
import { setSignOutHandler } from "@/services/api";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    ui: uiReducer,
    borrowers: borrowersReducer,
    agent: agentReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ["auth/setUser"],
      },
    }).concat(agentClient.middleware),
});

setSignOutHandler(() => store.dispatch(clearAuth()));

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
